import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { connect, useDispatch } from 'react-redux';
import LogsListing from '../../../../itrust_common/components/others/listings/LogsListing';
import CurrencyTypeView from '../../../../itrust_common/components/others/CurrencyTypeView';
import { getCardBrandImg, getPaymentMethodLabel, humanize } from '../../../../itrust_common/components/HelperFunctions';
import Moment from 'moment';
import { DatePicker } from 'react-widgets';
import TruncateText from '../../../../itrust_common/components/others/TruncateText';
import SaleRefundPaymentForm from './SaleRefundPaymentForm';
import useOrgDateFormat from '../../../../itrust_common/components/others/helperHooks/useOrgDateFormat';
import DateFormatView from '../../../../itrust_common/components/others/DateFormatView';
import MakeRefundForm from './MakeRefundForm';
import { orderPaymentDelete, orderPaymentsLoad } from '../../../../redux/actions/order/orderPaymentActions';
import Alert from '../../../../itrust_common/components/Alert';

function SaleRefundList(props) {
  const { handlePaymentSubmit, onlineRefund, orderId,payments, type, orderPaymentSaving, makeRefundModule, AllowedPaymentMethods, noShowMakeRefund, userRole, NonOnlinePaymentMethods } = props
  const [activeMethod, setActiveMethod] = useState('')
  const [activeMethodRecords, setActiveMethodRecords] = useState(payments || [])
  const [editPayment, setEditPayment] = useState({})
  const dispatch = useDispatch()
  const dateFormatType = useOrgDateFormat()

  useEffect(() => {
    handleMethodChange(activeMethod)
    return () => {
      setEditPayment({})
    }
  }, [payments])

  const handleMethodChange = (method) => {
    setActiveMethod(method)
    if (method) {
      setActiveMethodRecords(payments.filter(item => item.mode_of_payment === method))
    }
    else {
      setActiveMethodRecords(payments)
    }
  }
  const handlePaymentDelete = (payment) => {
    Alert.warning(
      'Are you sure you want to delete this payment? This action cannot be undone.',
      async (confirmed) => {
        if (!confirmed) {
          return
        }

        await dispatch(
          orderPaymentDelete(orderId, {
            payments_attributes: {
              id: payment.id
            }
          })
        )

        await dispatch(
          orderPaymentsLoad(orderId, {
            rpp: 999,
            filter: {
              payment_type: ['sale', 'refund'],
              amount_present: true
            },
            include: ['staff']
          })
        )
      }
    )
  }
  const LogsHead = [
    { title: 'ID', className: 'text-nowrap' },
    { title: 'Amount', className: 'text-nowrap' },
    { title: `Mode of ${type === 'refund' ? 'Refund' : 'Payment'}`, className: 'text-nowrap z-index-2' },
    { title: `Refund At`, className: 'text-nowrap z-index-2', hideFor: (type === 'sale' ? true : (type === 'refund' && makeRefundModule)) },
    { title: `Charged On`, className: 'text-nowrap z-index-2', hideFor: (type === 'refund' && !makeRefundModule) },
    { title: 'Check#', className: 'text-nowrap', hideFor: !(activeMethod === 'check' || activeMethod === '') },
    { title: 'Card Type', className: 'text-nowrap', hideFor: !(activeMethod === 'card' || activeMethod === '') },
    { title: `${type === 'refund' ? 'Refunded By' : 'Collected By'}`, className: 'text-nowrap z-index-2' },
    { title: 'Comment', className: 'text-nowrap z-index-2', hideFor: !!['online', 'device', 'pay_by_text', 'link'].includes(activeMethod) },
    { title: 'Refundable Amount', className: 'text-nowrap z-index-2', hideFor: (!makeRefundModule) }, // Make Refund
    { title: 'Refund Amount', className: 'text-nowrap z-index-2', hideFor: (!makeRefundModule || ['online', 'device', 'pay_by_text', 'link'].includes(activeMethod)) }, // Make Refund
    { title: 'Make Refund', className: 'text-nowrap z-index-2', hideFor: !(type === 'refund' && !noShowMakeRefund) },
    { title: 'Action', className: 'text-nowrap z-index-2', hideFor: !(type === 'sale' && activeMethod === '' && userRole !== 'non_admin') },
  ]

  const handlePaymentEdit = (payment) => {
    setEditPayment(payment)
  }

  const RenderRefundLogs = (props) => {
    const { log: payment } = props

    return (
      <tr className="text-dark border-bottom border-light border-bottom-2">
        <td>#{payment.id}</td>
        <td>
          <CurrencyTypeView amount={payment.amount} />
          {payment.online_payment_details?.card_type && <span className='ml-5'>
            {getCardBrandImg(payment.online_payment_details.card_type, 'mx-1')}
            {payment.online_payment_details.last4digit}
          </span>}
        </td>
        <td>{getPaymentMethodLabel(payment.mode_of_payment)}</td>
        <td className='width-11'>
          {['online', 'device', 'pay_by_text', 'link'].includes(activeMethod) ?
            <>
              {(payment.online_payment_details?.refund_details?.refund_at) &&
                <span> {Moment(payment.online_payment_details?.refund_details?.refund_at).format("YYYY/MM/DD")}</span>
              }
            </> :
            <DatePicker
              value={payment.payment_date ? new Date(payment.payment_date) : null}
              format={dateFormatType}
              editFormat={dateFormatType}
              placeholder={dateFormatType}
              onChange={(date) => handlePaymentSubmit({ id: payment.id, payment_date: Moment(date).format("YYYY/MM/DD"), date_update: true })}
            />
          }
        </td>
        {(activeMethod === 'check' || activeMethod === '') &&
          <td>{payment.check_details && payment.check_details.check_number}</td>
        }
        {(activeMethod === 'card' || activeMethod === '') &&
          <td>{payment.card_details && payment.card_details.card_type}</td>
        }
        <td>
          {['online', 'device', 'pay_by_text', 'link'].includes(activeMethod) ?
            <>
              {(payment.online_payment_details?.refund_details?.charge_id) &&
                <span>{payment.staff_attributes?.name}</span>
              }
            </> :
            <span>{payment.staff_attributes?.name}</span>
          }
        </td>
        {!['online', 'device', 'pay_by_text', 'link'].includes(activeMethod) && <td>{payment.notes}</td>}
        {(['online', 'device', 'pay_by_text', 'link', ''].includes(activeMethod) && !noShowMakeRefund) &&
          <td>
            {payment.online_payment_details?.payment_intent_id ?
              <>
                {(payment.online_payment_details?.refund_details?.charge_id || payment.payment_type == 'refund') ?
                  <button type="button" className="btn btn-primary px-4 py-2 disabled">Refunded</button> :
                  <button type="submit" className={`btn btn-outline-primary px-4 py-2`} onClick={() => onlineRefund(payment)}>Refund</button>
                }
              </>
              : ''
            }
          </td>
        }
      </tr>
    )
  }

  const RenderLogs = (props) => {
    const { log: payment } = props

    return (
      <>
        {editPayment.id == payment.id ?
          <SaleRefundPaymentForm
            payment={payment}
            setEditPayment={setEditPayment}
            dateFormatType={dateFormatType}
            initialValues={payment}
            NonOnlinePaymentMethods={NonOnlinePaymentMethods}
          /> :
          <tr className="text-dark border-bottom border-light border-bottom-2">
            <td>#{payment.id}</td>
            <td>
              <CurrencyTypeView amount={payment.amount} />
              {payment.online_payment_details?.card_type && <span className='ml-5'>
                {getCardBrandImg(payment.online_payment_details.card_type, 'mx-1')}
                {payment.online_payment_details.last4digit}
              </span>}
            </td>
            <td>{getPaymentMethodLabel(payment.mode_of_payment)}</td>
            <td className="width-11">
              <DateFormatView date={payment.payment_date} />
            </td>
            {(activeMethod === 'check' || activeMethod === '') &&
              <td>{payment.check_details && payment.check_details.check_number}</td>
            }
            {(activeMethod === 'card' || activeMethod === '') &&
              <td>{payment.card_details && payment.card_details.card_type}</td>
            }
            <td>{payment.staff_attributes?.name}</td>
            {!["device", "link", "void"].includes(activeMethod) && <td>
              <TruncateText textCount={10}>
                {payment.notes}
              </TruncateText>
            </td>}
            {(activeMethod === '' && type !== 'refund' && userRole !== 'non_admin' && !["device", "link", "online", 'pay_by_text'].includes(payment.mode_of_payment)) && <td>
              <span className="badge badge-pill badge-primary mr-5 pointer" onClick={() => handlePaymentEdit(payment)}><i className="la la-pencil" /></span>
                {['cash', 'check', 'other', 'imported'].includes(payment.mode_of_payment) && (
                  <i
                    className="la la-trash text-danger pointer"
                    onClick={() => handlePaymentDelete(payment)}
                  />
                )}
            </td>}
          </tr>
        }
      </>
    )
  }

  return (
    <div className='p-5'>
      <div>
        <div className='d-flex align-items-center bg-light border-radius-6 pt-2 overflow-auto hidden-scroll'>
          <span className={`px-5 line-height-3 cursor-pointer border-bottom border-2 ${activeMethod === '' ? 'text-primary border-primary' : ''}`} onClick={() => handleMethodChange('')}>All</span>
          {AllowedPaymentMethods.map((method) => (
            <span key={`payment_details_${method.value}`} className={`px-6 line-height-3 cursor-pointer border-bottom border-2 text-nowrap ${activeMethod === method.value ? 'text-primary border-primary' : ''}`} onClick={() => handleMethodChange(method.value)}>
              <span dangerouslySetInnerHTML={{ __html: method.label }} />
            </span>
          ))}
        </div>
      </div>
      {(makeRefundModule) ?
        <div>
          {/* <div className='d-flex justify-content-end'>
            <SaveButton saving={orderPaymentSaving} label="Refund" savingLabel="Updating" handleOnClick={() => dispatch(submit('orderRefundForm'))} />
          </div>
          <PaymentForm form="orderRefundForm" onSubmit={handlePaymentSubmit} paymentType='refund' /> */}
          <MakeRefundForm
            payments={activeMethodRecords}
            LogsHead={LogsHead}
            activeMethod={activeMethod}
            onlineRefund={onlineRefund}
            dateFormatType={dateFormatType}
            noShowMakeRefund={noShowMakeRefund}
            initialValues={{ payments: activeMethodRecords }}
            orderPaymentSaving={orderPaymentSaving}
            handlePaymentSubmit={handlePaymentSubmit}
          />
        </div> :
        <div className='px-2 height-50 overflow-auto' style={{ minHeight: '24rem' }}>
          <LogsListing
            TableHead={LogsHead}
            loading={orderPaymentSaving}
            tableClasses="thead-0"
          >
            {activeMethodRecords.length ?
              activeMethodRecords.map((log) => (
                <React.Fragment key={`row_${log.id}`}>
                  {type === 'refund' ? RenderRefundLogs({ log }) : RenderLogs({ log })}
                </React.Fragment>
              )) :
              (!orderPaymentSaving && <tr>
                <td colSpan={14} className='text-center font-size-18'>No Record Found</td>
              </tr>)
            }
          </LogsListing>
        </div>
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  const { auth, order: { order } } = state
  return {
    userRole: auth.user?.role,
    orderId: order.id,
  }
}

export default connect(mapStateToProps)(SaleRefundList);